import { bannerSlots } from "@stubhub/broadway-foundation";
import { sva } from "@stubhub/broadway-foundation/css";

export const priceTrendBannerRecipe = sva({
  slots: bannerSlots,
  className: "priceTrendBanner",
  base: {
    wrapper: {
      borderBlockWidth: "primitives.25",
      borderInlineWidth: "primitives.25",
      borderBlockStyle: "solid",
      borderInlineStyle: "solid",
      borderBlockColor: "border",
      borderInlineColor: "border",
      marginInline: "[-4px]",
      width: "[calc(100% + 24px)]",
    },
  },
});
